import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { Paths } from "../../../paths";
import { EntTheNeedsOfThePopulation } from "../../../models/organic/theNeedsOfThePopulation";
import { EntTheNeedsOfThePopulationFilter } from "../../../models/filters/organic/theNeedsOfThePopulationFilter";

export const theNeedsOfThePopulationApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getTheNeedsOfThePopulationList: builder.query<ResponseDataGet<EntTheNeedsOfThePopulation>, EntTheNeedsOfThePopulationFilter>({
	  query: (filter) => ({
		url: `${ Paths.organic.theNeedsOfthePopulation }/needs/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getTheNeedsOfThePopulationById: builder.query<ResponseDataGet<EntTheNeedsOfThePopulation>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.theNeedsOfthePopulation }/needs/${ id }`,
		method: 'GET',
	  }),
	}),

	addTheNeedsOfThePopulation: builder.mutation<ResponseDataGet<EntTheNeedsOfThePopulation>, EntTheNeedsOfThePopulation>({
	  query: (body) => ({
		url: `${ Paths.organic.theNeedsOfthePopulation }/needs`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editTheNeedsOfThePopulation: builder.mutation<ResponseDataGet<EntTheNeedsOfThePopulation>, EntTheNeedsOfThePopulation>({
	  query: (body) => ({
		url: `${ Paths.organic.theNeedsOfthePopulation }/needs/${ body.id }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteTheNeedsOfThePopulation: builder.mutation<ResponseDataGet<EntTheNeedsOfThePopulation>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.theNeedsOfthePopulation }/needs/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useGetTheNeedsOfThePopulationListQuery,
  useGetTheNeedsOfThePopulationByIdQuery,
  useAddTheNeedsOfThePopulationMutation,
  useEditTheNeedsOfThePopulationMutation,
  useDeleteTheNeedsOfThePopulationMutation,
  useLazyGetTheNeedsOfThePopulationListQuery
} = theNeedsOfThePopulationApi;
